import { render, staticRenderFns } from "./TenantDeleteBtn.vue?vue&type=template&id=2dcd243e&"
import script from "./TenantDeleteBtn.vue?vue&type=script&lang=js&"
export * from "./TenantDeleteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports